import { PropertyValuePill } from 'components/PropertyValuePill/PropertyValuePill'
import { type PropertyValue } from 'api/clients/PropertyClient'

interface WorkflowProps {
  workflowDefaultProperty: Pick<PropertyValue, 'value' | 'meta'> | undefined
}

export const WorkflowStatusMessage = ({ workflowDefaultProperty }: WorkflowProps) => {
  if (!workflowDefaultProperty) return null

  return (
    <>
      {'The status will change to '}
      <PropertyValuePill propertyValue={workflowDefaultProperty} />.
    </>
  )
}

interface InheritAccessProps {
  parentsCount: number
  currentParentTitle: string | undefined
}

export const InheritAccessMessage = ({ parentsCount, currentParentTitle }: InheritAccessProps) => {
  if (parentsCount === 0) return null

  if (parentsCount > 1) return <>Anyone with inherited access will no longer have access.</>

  if (!currentParentTitle) return null

  return (
    <>
      Anyone with inherited access from <b>{currentParentTitle}</b> will no longer have access.
    </>
  )
}
